import React from 'react';
import {Link} from 'react-router-dom';
import AspectRatioImage from '../AspectRatioImage/AspectRatioImage';
import PropTypes from 'prop-types';
import './Card.less';

export const LinkType = ({link, type, children}) => {
    const isExternal = type === 'ExternalLink';

    if (isExternal) {
        return (
            <a href={link} className="Card__link Card__link--external">
                {children}
            </a>
        );
    }

    return (
        <Link to={link} className="Card__link Card__link--internal">
            {children}
        </Link>
    );
};

const Card = ({title, content, link, image, __typename}) => {
    return (
        <div className="Card">
            <LinkType link={link} type={__typename}>
                {image && <AspectRatioImage {...image} className="Card__top" />}
                {/*TODO review is content is ever used*/}
                {(title || content) && (
                    <div className="Card__bottom">
                        <div className="Card__caption">
                            <span className="Card__title">{title}</span>
                        </div>
                        <div className="Card__content">
                            <span>{content}</span>
                        </div>
                    </div>
                )}
            </LinkType>
        </div>
    );
};

Card.propTypes = {
    title: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        description: PropTypes.string,
    }),
    link: PropTypes.string.isRequired,
    __typename: PropTypes.string.isRequired,
    content: PropTypes.string,
};

export default Card;
